export const moduleRoutes = {
  root: 'txn-inquiry',
  childForms: {
    balanceInquiry: {
      data: { title: 'Consultas' },
      requireAuth: true,
      functions: [],
      route: 'saldo',
    },
    accountMovements: {
      data: { title: 'Consultas' },
      requireAuth: true,
      functions: [],
      route: 'movimientos',
    },
  },
  layout: 'main',
  loadChildren: () => import('src/app/pages/txn-inquiry/txn-inquiry.module').then(m => m.TxnInquiryModule),
};
